// src/Global.js

const base_url = process.env.REACT_APP_API_BASE_URL;
const Apitoken = process.env.REACT_APP_API_TOKEN;

const Authtoken = localStorage.getItem('auth_token');
const auth_id = localStorage.getItem('auth_id');
const role_id = localStorage.getItem('role_id');
const user_location = localStorage.getItem('user_location');

const AWS_ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
const AWS_DEFAULT_REGION = process.env.REACT_APP_AWS_DEFAULT_REGION;
const AWS_BUCKET = process.env.REACT_APP_AWS_BUCKET;
const AWS_USE_PATH_STYLE_ENDPOINT = process.env.REACT_APP_AWS_USE_PATH_STYLE === 'true';
const AWS_BUCKET_URL = process.env.REACT_APP_AWS_BUCKET_URL;

const user_type = localStorage.getItem('user_type');

const season_id = localStorage.getItem('season_id');
const season_name = localStorage.getItem('season_name');
const season_start = localStorage.getItem('season_start');
const season_end = localStorage.getItem('season_end');

export {
  base_url,
  Apitoken,
  Authtoken,
  auth_id,
  role_id,
  user_location,
  AWS_ACCESS_KEY_ID,
  AWS_SECRET_ACCESS_KEY,
  AWS_DEFAULT_REGION,
  AWS_BUCKET,
  AWS_USE_PATH_STYLE_ENDPOINT,
  AWS_BUCKET_URL,
  user_type,
  season_id,
  season_name,
  season_start,
  season_end
};
